import { render, staticRenderFns } from "./LToolTip.vue?vue&type=template&id=4704883c&scoped=true&"
import script from "./LToolTip.vue?vue&type=script&lang=js&"
export * from "./LToolTip.vue?vue&type=script&lang=js&"
import style0 from "./LToolTip.vue?vue&type=style&index=0&id=4704883c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704883c",
  null
  
)

export default component.exports